export default {
  created_at: {
    name: "操作时间",
    attr: "created_at",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请选择", trigger: "blur" },
    ],
    configs: {
      type: "swim",
      change: "onChangeSwim",
      placeholder: "请选择",
      selData: [{ label: "选项一", value: 1 }],
    },
  },
  user_realname: {
    name: "操作人",
    attr: "user_realname",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "device",
      placeholder: "请输入",
    },
  },
  user_name: {
    name: "操作账号",
    attr: "user_name",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "sensor",
      placeholder: "请输入",
    },
  },
  status_text: {
    name: "状态",
    attr: "status_text",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "sensor",
      placeholder: "请输入",
    },
  },
  total_failure: {
    name: "总失败数",
    attr: "total_failure",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "sensor",
      placeholder: "请输入",
    },
  },
  total_success: {
    name: "总成功数",
    attr: "total_success",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "sensor",
      placeholder: "请输入",
    },
  },
  error_message: {
    name: "错误信息",
    attr: "error_message",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "sensor",
      placeholder: "请输入",
    },
  },
};
